import type { UpdateRepairRequest } from '@/lib/service/ecs/contracts';
import { devError } from '@/lib/utils/devLog';

const REPAIR_UPDATE_GENERIC_FAILURE = 'REPAIR_UPDATE_GENERIC_FAILURE';

export interface UpdateRepairDetailsQuery {
  countryCode: string;
  request: UpdateRepairRequest;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function readErrorMessage(json: unknown): string {
  if (!isRecord(json) || !Array.isArray(json.errors)) return '';
  const first = json.errors[0];
  if (isRecord(first) && typeof first.message === 'string' && first.message) return first.message;
  return '';
}

export function buildUpdateRepairUrl(countryCode: string): string {
  const params = new URLSearchParams({ countryCode });
  return `/api/service/update-repair?${params.toString()}`;
}

export async function updateRepairDetails({
  countryCode,
  request,
}: UpdateRepairDetailsQuery): Promise<void> {
  let response: Response;
  try {
    response = await fetch(buildUpdateRepairUrl(countryCode), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(request),
    });
  } catch (error) {
    devError('[repairDetailsUpdateClient] request failed:', error);
    throw new Error(REPAIR_UPDATE_GENERIC_FAILURE, { cause: error });
  }

  const json: unknown = await response.json().catch(() => null);
  if (!response.ok || !isRecord(json) || json.success !== true) {
    throw new Error(readErrorMessage(json) || REPAIR_UPDATE_GENERIC_FAILURE);
  }
}
